import { getLangCookie } from "@/utils/functions/cookieOperations";

interface Props {
  notMain?: boolean;
  rotate?: boolean;
}

const SvgPCMenuArrow: React.FC<Props> = ({
  notMain = false,
  rotate = false,
}) => {
  const isRTL = getLangCookie() === "ar";
  return (
    <svg
      style={{ marginInlineStart: 4 }}
      className={`rotate-arrow ${
        rotate
          ? notMain
            ? isRTL
              ? "anti-clockwise"
              : "clockwise"
            : "flip"
          : ""
      }`}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9944 5.3918C14.8362 5.39554 14.6858 5.46167 14.5761 5.57578L9.00029 11.1516L3.42451 5.57578C3.3686 5.5183 3.30173 5.47262 3.22786 5.44142C3.15399 5.41022 3.07462 5.39414 2.99443 5.39414C2.87507 5.39417 2.75844 5.4298 2.65943 5.49647C2.56042 5.56313 2.48355 5.65781 2.43864 5.7684C2.39372 5.87899 2.38281 6.00046 2.40729 6.11728C2.43177 6.2341 2.49054 6.34097 2.57607 6.42422L8.57607 12.4242C8.6886 12.5367 8.84119 12.5999 9.00029 12.5999C9.1594 12.5999 9.31199 12.5367 9.42451 12.4242L15.4245 6.42422C15.5116 6.34043 15.5714 6.23227 15.5961 6.11392C15.6207 5.99556 15.609 5.87253 15.5625 5.76094C15.516 5.64935 15.4369 5.5544 15.3355 5.48853C15.2342 5.42266 15.1153 5.38894 14.9944 5.3918Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SvgPCMenuArrow;
